// extracted by mini-css-extract-plugin
export default {"title":"CreateLiber_title__W8kNb","input":"CreateLiber_input__RVzcs","label":"CreateLiber_label__gwFiO","select":"CreateLiber_select__oAu4m","btn":"CreateLiber_btn__5vrcR"};